import React from "react";
import styled from "styled-components";

const ProjectLink = styled.a`
  color: #010f7a;
  text-decoration: none;
  padding: 1px 0px;
  transition: background 0.05s ease, color 0.05s ease;

  &:visited {
    color: #010f7a;
  }

  &:hover {
    background: #000080;
    color: #fff;
  }

  &:active {
    background: #000060;
    color: #fff;
  }
`;

const SectionTitle = styled.h3`
  margin: 1.4em 0 0.8em;
`;

const ProjectEntry = styled.div`
  margin-bottom: 1.2em;

  p {
    margin: 0.2em 0;
  }
`;

function Projects() {
  return (
    <div>
      <h2>Featured Projects</h2>

      <SectionTitle>Applications</SectionTitle>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://www.youtube.com/watch?v=QOHvbyZjVDM"
            target="_blank"
            rel="noreferrer"
          >
            <b>Eleven</b>
          </ProjectLink>
        </p>
        <p>
          Semantic search engine for my undergraduate classes,
          suggesting courses within milliseconds.{" "}
        </p>
      </ProjectEntry>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://github.com/codegen-sh/deep-research"
            target="_blank"
            rel="noreferrer"
          >
            <b>Deep Research</b>
          </ProjectLink>
        </p>
        <p>
          Chat interface to thoroughly analyze any open source codebase.
        </p>
      </ProjectEntry>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://www.youtube.com/watch?v=h1daCgDtizM"
            target="_blank"
            rel="noreferrer"
          >
            <b>tldw</b>
          </ProjectLink>
        </p>
        <p>
          Video summarization platform with trasncriptions and intelligent insights.
        </p>
      </ProjectEntry>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://www.youtube.com/watch?v=KO793dX0Mso"
            target="_blank"
            rel="noreferrer"
          >
            <b>Animanic</b>
          </ProjectLink>
        </p>
        <p>
          Text-to-video generation to turn any educational topic into an engaging video.
        </p>
      </ProjectEntry>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://github.com/vishalshenoy/ghiblify"
            target="_blank"
            rel="noreferrer"
          >
            <b>Ghiblify</b>
          </ProjectLink>
        </p>
        <p>
          {" "}
          Image diffusion pipeline to turn everyday photos into Studio
          Ghibli style artwork, two years before the trend.{" "}
        </p>
      </ProjectEntry>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://www.youtube.com/watch?v=HKn7CoC47WQ"
            target="_blank"
            rel="noreferrer"
          >
            <b>coverart.lol</b>
          </ProjectLink>
        </p>
        <p>
          Generative cover art to personalize Spotify blends, from link  to image.
        </p>
      </ProjectEntry>

      <SectionTitle>Research</SectionTitle>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://doi.org/10.1109/BIBM52615.2021.9669886"
            target="_blank"
            rel="noreferrer"
          >
            <b>Vascular1</b>
          </ProjectLink>
        </p>
        <p>
          Virtual reality simulation to train surgical residents for
          ultrasound guided vascular access procedures.
        </p>
      </ProjectEntry>
      <ProjectEntry>
        <p>
          <ProjectLink
            href="https://doi.org/10.1109/SSCI50451.2021.9659919"
            target="_blank"
            rel="noreferrer"
          >
            <b>CovXR</b>
          </ProjectLink>
        </p>
        <p>
          Machine learning algorithm to detect COVID-19 induced pneumonia
          features on chest radiographs.
        </p>
      </ProjectEntry>
    </div>
  );
}

export default Projects;
